import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { ModalInfo } from 'Douleutaras/types';
import { StepsModal } from 'Douleutaras/components/Modal/StepsModal/StepsModal';
import RegularButton from 'Douleutaras/components/RegularButton/RegularButton';
import { getModalContent, selectModalBySlug } from 'Douleutaras/redux/data/modals/modalsSlice';
import InfoCircleSvg from 'Assets/layout/statCenter/info-circle.svg';

import './InfoModal.scss';

const InfoModal = ({ modalSlug, contentTemplate, text = false, hideButton = true}:
                     { modalSlug: string; contentTemplate?: React.ReactNode; text?: string | boolean, hideButton?: boolean }) => {
  const { t } = useTranslation();
  const [ infoModalOpen, setInfoModalOpen ] = useState(false);
  const dispatch = useDispatch();

  const currentInfo = useAppSelector(state => selectModalBySlug(
    state,
    // @ts-ignore
    { slug: modalSlug })
  ) as ModalInfo;

  const openModal = async () => {
    if (currentInfo.attributes.title === undefined) {
      await dispatch(getModalContent(currentInfo.id));
    }

    setInfoModalOpen(true);
  };

  return (
    <>
      { currentInfo &&
      <>
        { !text
          ? <button styleName="chart-card-info-button"
                    data-tracking="info-modal"
                    data-tracking-value-info-modal={modalSlug}
                    onClick={() => openModal()}>
              <img src={InfoCircleSvg} alt="Info cirle" />
            </button>
          : <span styleName="chart-card-info-text" onClick={() => openModal()}>{text}</span>
        }
        <StepsModal isOpen={infoModalOpen} dismissCallback={() => setInfoModalOpen(false)}>
          <div styleName="chart-popup-title">{currentInfo.attributes.title}</div>
          <div styleName="chart-popup-content">
            { React.isValidElement(contentTemplate)
              ? React.cloneElement(contentTemplate, {
                  // @ts-ignore
                  content: currentInfo.attributes.content,
                  slug: modalSlug,
                  key: 'cloned-content'
                })
              // @TODO: Refactor to plain content
              : <div dangerouslySetInnerHTML={{__html: currentInfo.attributes.content}} />
            }
          </div>

          {!hideButton &&
            <div styleName="chart-popup-footer">
              <RegularButton modifier="primary"
                             size="large"
                             onClick={() => setInfoModalOpen(false)}
                             title={t('T.CLOSE')} />
            </div>
          }
        </StepsModal>
      </>
      }
    </>
  );
};

export default InfoModal;
